import { render, staticRenderFns } from "./NenhumaInformacaoEncontrada.vue?vue&type=template&id=3a025a4e&scoped=true"
import script from "./NenhumaInformacaoEncontrada.vue?vue&type=script&lang=js"
export * from "./NenhumaInformacaoEncontrada.vue?vue&type=script&lang=js"
import style0 from "./NenhumaInformacaoEncontrada.vue?vue&type=style&index=0&id=3a025a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a025a4e",
  null
  
)

export default component.exports